export default {
  myResources: 'Mis recursos',
  schoolsGroupResources: 'Recursos de la red',
  newResource: 'Crear nuevo',
  emptyResourcesTitle: '¡Todavía no creaste recursos!',
  emptyResourcesDesc: 'Anímate a crear contenido para compartir con tus colegas',
  showMore: 'VER MÁS'
}

export const en = {
  myResources: 'My resources',
  schoolsGroupResources: 'Network resources',
  newResource: 'Create new',
  emptyResourcesTitle: 'You have not yet created resources!',
  emptyResourcesDesc: 'Create content to share with your colleagues',
  showMore: 'SEE MORE'
}

export const ca = {
  myResources: 'Els meus recursos',
  schoolsGroupResources: 'Recursos de la xarxa',
  newResource: 'Crear nou',
  emptyResourcesTitle: 'Encara no has creat recursos!',
  emptyResourcesDesc: 'Anima\'t a crear contingut per compartir amb els col·legues',
  showMore: 'VEURE MÉS'
}
